import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Button, Form, Spinner } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { failedMessage } from "utils/httpClient";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { isEmpty } from "utils/utils";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import { saveToLocalStorage } from "utils/LocalStorageUtils";
import TemplateViewing from "pages/modalPopup/templateViewing";
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
import LoginAskModal from "pages/loginaskmodal";
import { FaBookmark, FaRegBookmark, FaTimes } from "react-icons/fa";
import HomeTabSlider from "./hometabslider";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
// const isMdScreen = window.innerWidth >= 768 && window.innerWidth <= 1024;

const HomeTemplateGallery = ({searchTemplate, selectCategoryId, setSelectCategoryId,selectedCategoryId, setSelectedCategoryId}) => {
  const navigate = useNavigate();
  const boxRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isAuth, setIsAuth] = useState(false);
  const [isMdScreen, setIsMdScreen] = useState(false);

  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData?.token) {
      setIsAuth(true)
    }
  }, []);

  const handleViewClick = (template) => {
    setSelectedTemplate(template);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTemplate(null);
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isFavourite = urlParams.get('is_favourite');
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [templatesList, setTemplatesList] = useState([]);
  // const [selectCategoryId, setSelectCategoryId] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const [pageChanging, setPageChanging] = useState(false);

  const getTemplatesList = async (item = '', offset = 0) => {
    // setLoading(true)
    // let params = { limit: 9, offset: currentPage === 0 ? 0 : currentPage - 1, shuffle: false };
    let params = { limit: 4, offset: offset === 0 ? 0 : offset - 1, shuffle: false, order_by: 'asc' };
    if (!isEmpty(selectCategoryId)) {
      params["category_id"] = selectCategoryId;
    } else if (!isEmpty(localStorage.getItem('selectCategoryId'))) {
      params["category_id"] = localStorage.getItem('selectCategoryId');
    }
    if (!isEmpty(item)) {
      // delete params.category_id
      params["search_by"] = item
    }
      if (params.category_id != undefined && params.category_id != '') {
      delete params.search_by
    }
    const { data } = await apiCall("post", apiEndPoint.SEARCHTEMPLATE, params);
    if (data.status === 200) {
      setTemplatesList(data.data);
      setTotalPages(Math.ceil(data?.total_data / 200));
    } else {
      setTemplatesList([]);
      failedMessage(data.message);
    }
    await localStorage.setItem('selectCategoryId', '')
    setLoading(false)
  };
  useEffect(() => {
    if (!isEmpty(localStorage.getItem('selectCategoryId'))) {
      setSelectCategoryId(localStorage.getItem('selectCategoryId'))
    }
    getTemplatesList(searchCategory, currentPage)
  }, [currentPage, isFavourite])

  useEffect(() => {
    getTemplatesList(searchCategory, 0)
  }, [selectCategoryId])
  useEffect(() => {
    getTemplatesList(searchTemplate, 0)
  }, [searchTemplate])

  const handleAllTemplateData = () => {
    setSearchCategory('')
    setSelectCategoryId('')
    setCurrentPage(0)
    localStorage.setItem('selectCategoryId', '')
    getTemplatesList(searchCategory, 0)
  }
  const handlePageChange = async (page) => {
    setPageChanging(true);
    setCurrentPage(page);
    await getTemplatesList(searchCategory, page);
    setPageChanging(false);
  };

  const [categories, setCategories] = useState([]);
  const handleGetCategory = async (cat_name) => {
    if (!isEmpty(cat_name)) {
      const params = { limit: 20, offset: 0, category_name: cat_name }
      const { data } = await apiCall("post", apiEndPoint.GETCATEGORY, params);
      if (data.status === 200) {
        setCategories(data.data);
      } else {
        setCategories([]);
        // failedMessage(data.message);
      }
    } else {
      setCategories([]);
    }
  };
  const handleSelectCategory = (item) => {
    setSearchCategory(item?.category_name)
    setSelectCategoryId(item?._id);
    setCategories([])
  }

  const [showLoginAskModal, setShowLoginAskModal] = useState(false);
  const handleLoginAskModal = () => {
    setShowLoginAskModal(true);
  }
  const handleCloseLoginAskModal = () => {
    setShowLoginAskModal(false);
  }

  // Function to handle clicks outside the box
  const handleClickOutside = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setCategories([])
    }
  };


  useEffect(() => {
    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Clean up the event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [savedItems, setSavedItems] = useState(new Set());

  const toggleSave = async (id) => {
    setSavedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
    const params = { template_id: id }
    const { data } = await apiCall("post", apiEndPoint.ADDREMOVEWISHLISTTEMPLATE, params);
  };

  const toggleSaveTemp = async (id) => {
    setSavedItems(prev => {
      const newSet = new Set(prev);
      newSet.add(id);
      return newSet;
    });
  };
  const getWishlistTemplateList = async (id) => {
    const { data } = await apiCall("get", apiEndPoint.GETWISHLISTTEMPLATE);
    if (data.status === 200) {
      const array = data.data.map(item => toggleSaveTemp(item.template_id))
    }
  };

  useEffect(() => {
    getWishlistTemplateList()
  }, [])
  useEffect(() => {
    const handleResize = () => {
      setIsMdScreen(window.innerWidth >= 1400); // Assuming "md" breakpoint is 768px or higher
    };

    handleResize(); // Check on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const arrowStyle = {
    position: "absolute",
    bottom: 0,
    zIndex: 99,
    cursor: "pointer",
  };

  const customLeftArrow = (
    <div style={{ ...arrowStyle, left: isMdScreen ? "41.5%" : "0", display: "flex", justifyContent: "center", alignItems: 'baseline' }}
      onClick={() => handlePageChange(currentPage - 1)}>
      <Button
        variant="light"
        style={{
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
          backgroundColor: "white",
          padding: 0,
          border: "2px solid #ccc",
          borderRadius: "50%",
        }}
      >
        <BsChevronLeft color="#E86A33" size={12} />
      </Button>
      <p style={{ marginLeft: "1rem", fontSize: "16px", color: "#000" }}>Prev</p>
      <p style={{ marginLeft: "1rem", fontSize: "16px", color: "#E86A33" }} className="d-none d-xl-block"> | </p>
    </div>
  );

  const customRightArrow = (
    <div style={{ ...arrowStyle, right: isMdScreen ? "41.5%" : "0", display: "flex", justifyContent: "center", alignItems: 'baseline' }}
      onClick={() => handlePageChange(currentPage + 1)}      >
      <p style={{ marginRight: "1rem", fontSize: "16px", color: "#000" }}>Next</p>
      <Button
        variant="light"
        style={{
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
          backgroundColor: "white",
          padding: 0,
          border: "2px solid #ccc",
          borderRadius: "50%",
        }}
      >
        <BsChevronRight color="#E86A33" size={12} />
      </Button>
    </div>
  );

  return (
    <>
      <Row className="my-4">
        <Col lg={12}>
         
          <HomeTabSlider
            setSelectCategoryId={setSelectCategoryId}
            selectCategoryId={selectCategoryId}
            setSelectedCategoryId={setSelectedCategoryId}
            selectedCategoryId={selectedCategoryId}
            searchCategory={searchCategory}
            handleAllTemplateData={handleAllTemplateData}
            languageData={languageData}
            setCurrentPage={setCurrentPage}
          />
        </Col>
      </Row>
      <>
        <div>
          {(pageChanging || loading) ? (
            <div style={{ textAlign: 'center', marginTop: '4rem' }}>
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            templatesList.length > 0 ? (
              <div>
                <Row>
                  {templatesList.map((template, index) => (
                    <Col lg={3} md={6} sm={6} className="mb-4" key={index} style={{ padding: '0 18px' }}>
                      <Card className="position-relative" style={{
                        border: '2px solid #ccc',
                        borderRadius: '10px'
                      }}>
                        <Card.Img variant="top" className="img-template" src={template.thumbnail} alt={template.template_name} style={{ borderRadius: '8px' }} />
                        <div className="button-overlay">
                          <Button variant="outline-primary" className="me-2"
                            onClick={() => {
                              if (isAuth) {
                                saveToLocalStorage('selectTemplate', template); saveToLocalStorage("selectOrderDetail", null); navigate("/templateform")
                              } else {
                                handleLoginAskModal();
                              }
                            }}>
                            {languageData?.edit}
                          </Button>
                          <Button variant="primary" onClick={() => handleViewClick(template)}>
                            {languageData?.view}
                          </Button>
                        </div>
                      </Card>
                      {/* Save/Unsave Section */}
                      {/* <div style={{ margin: '5px' }}>
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}>
                          <Card.Title style={{
                            fontSize: '14px',
                            margin: 0,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flexGrow: 1,
                          }}>
                            {template?.title}
                          </Card.Title>

                          {isAuth &&
                            <span
                              onClick={() => toggleSave(template._id)}
                              style={{
                                cursor: 'pointer',
                                marginLeft: '10px',
                                flexShrink: 0,
                              }}
                              title={savedItems.has(template._id) ? 'Unsave' : 'Save'}
                            >
                              {savedItems.has(template._id) ? (
                                <FaBookmark color="#ff671f" />
                              ) : (
                                <FaRegBookmark color="#999" />
                              )}
                            </span>
                          }
                        </div>
                      </div> */}
                    </Col>
                  ))}
                </Row>
                <div style={{ position: "relative", height: "40px", marginTop: "2rem" }}>
                  {customLeftArrow}
                  {customRightArrow}
                </div>

              </div>
            ) : (
              <div style={{ textAlign: 'center', marginTop: '4rem' }}>
                <img src='/assets/images/nofound.png' style={{ textAlign: 'center', width: '60%' }} />
              </div>
            )
          )}

        </div>

        {/* Modal for Viewing Template */}
        <TemplateViewing showModal={showModal} handleCloseModal={handleCloseModal} selectedTemplate={selectedTemplate} handleCloseLoginAskModal={handleCloseLoginAskModal} showLoginAskModal={showLoginAskModal} handleLoginAskModal={handleLoginAskModal} />
        {showLoginAskModal && <LoginAskModal handleCloseLoginAskModal={handleCloseLoginAskModal} showLoginAskModal={showLoginAskModal} />}
      </ >
    </>
  );
};

export default HomeTemplateGallery;